import { observer }        from 'mobx-react-lite';
import currentEditorStore  from '@/TokamapEditor/stores/currentEditorStore';
import AreaSidebar         from '@/TokamapEditor/ux/AreaSidebar/AreaSidebar';
import PlaceShapePanel     from '@/TokamapEditor/ux/PlaceShapePanel';
import UnlinkedShapePlace  from '@/TokamapEditor/ux/UnlinkedShapePlace';
import shapePlaceId        from '@/TokamapEditor/helpers/shapePlaceId';

const ShapeSidebar = observer(() => {
	const shapes = currentEditorStore.sidebarShapes;
	const shape = shapes.length === 1 ? shapes[0] : undefined;

	if (!shape || currentEditorStore.isMultiSelection) return <AreaSidebar />;

	const placeId = shapePlaceId(shape);

	if (placeId) return <PlaceShapePanel key={placeId} shape={shape} placeId={placeId} />;

	if (shape.shapeKind === 'image' || shape.shapeKind === 'line') return <AreaSidebar />;

	return (
		<AreaSidebar
			top={<UnlinkedShapePlace key={shape.id} shape={shape} />}
			settingsHidden={currentEditorStore.freshShapeId === shape.id || currentEditorStore.promotingShapeId === shape.id}
		/>
	);
});

export default ShapeSidebar;
